module.exports = __webpack_public_path__ + "img/cartes_bancaires.519544f2.svg";